// extracted by mini-css-extract-plugin
export default {"-large":"drag-drop-overlay-module__-large--uinRV","container":"drag-drop-overlay-module__container--hsZGF","content":"drag-drop-overlay-module__content--_tYjE"};